export default class Total {
  #count = 0;

  #sum = 0;

  #price = 0;

  COUNT_SELECTOR = '';

  PRICE_SELECTOR = '';

  SUM_SELECTOR = '';

  /**
   * @type SmCart
   */
  smCart;

  /**
   * @param {SmCart} smCart
   * @param {string} COUNT_SELECTOR
   * @param {string} PRICE_SELECTOR
   * @param {string} SUM_SELECTOR
   */
  constructor(
    smCart,
    COUNT_SELECTOR = '[data-total-count]',
    PRICE_SELECTOR = '[data-total-price]',
    SUM_SELECTOR = '[data-total-sum]',
  ) {
    this.smCart = smCart;
    this.COUNT_SELECTOR = COUNT_SELECTOR;
    this.PRICE_SELECTOR = PRICE_SELECTOR;
    this.SUM_SELECTOR = SUM_SELECTOR;
  }

  /**
   * @returns {Total}
   */
  updateSummary() {
    const count = document.querySelector(this.COUNT_SELECTOR);
    const sums = document.querySelectorAll(this.SUM_SELECTOR);

    if (count !== null) {
      count.textContent = this.#count.toString();
    }

    Array.prototype.filter.call(sums, (sum) => {
      if (sums !== null) {
        sum.textContent = this.#price.toString();
      }
    });

    const prices = document.querySelectorAll(this.PRICE_SELECTOR);
    // swapped sum and price
    Array.prototype.filter.call(prices, (price) => {
      price.textContent = this.#sum.toString();
    });

    const event = document.createEvent('Event');
    event.initEvent('Total:update', true, true);

    document.querySelector(this.SUM_SELECTOR)?.dispatchEvent(event);

    return this;
  }

  /**
   * @returns {number}
   */
  get Count() {
    return this.#count;
  }

  /**
   * @param {number} value
   */
  set Count(value) {
    this.#count = value;
  }

  /**
   * @returns {number}
   */
  get Sum() {
    return this.#sum;
  }

  /**
   * @param {number} value
   */
  set Sum(value) {
    this.#sum = value;
  }

  /**
   * @returns {number}
   */
  get Price() {
    return this.#price;
  }

  /**
   * @param {number} value
   */
  set Price(value) {
    this.#price = value;
  }
}
